import Basic from '@/components/page/Basic.js'

import {Config,AxiosWithJar} from '@/utility.js'

export default{
	extends: Basic,
	data: function () {
		return {
			customer:{ list:[] },
			complaint:{ p135: 0, spbu: 0 },
			loading: { table:true },
		}
	},
    methods:{

		/*
		async loadTop() {
			let url = Config().apiURL + "/customer/top?count=10"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.rfid.length) {
					this.top.rfid = result.data.rfid;
					this.top.voucher = result.data.voucher;
				}
			})
		},
		*/

		async loadCustomerList() {
			let url = Config().apiURL + "/customer/customerlist"
			await AxiosWithJar().get(url).then(result => {
				//if (result.data.customer.length) {
                if (result.data?.customer?.length > 0) {
					this.customer.list = result.data.customer;
				}
			})
		},

		async loadCustomerListPiutang() {
			let url = Config().apiURL + "/customer/customerlistpiutang"
			await AxiosWithJar().get(url).then(result => {
				//if (result.data.customer.length) {
                if (result.data?.customer?.length > 0) {
					this.customer.list = result.data.customer;
				}
			})
		},

		async loadComplaint(){
			let url =Config().apiURL+"/customer/complaint135?status=On+Progress&rekap=status";
			await AxiosWithJar().get(url).then(result=>{
				//if (result.data.data){
                if (result.data?.data?.length > 0) {
					this.complaint.p135 = result.data.data[0].Cnt;
				}
			})
			url =Config().apiURL+"/customer/complaintspbu?status=On+Progress&rekap=status";
			await AxiosWithJar().get(url).then(result=>{
				//if(result.data.data){
                if (result.data?.data?.length > 0) {
					this.complaint.spbu = result.data.data[0].Cnt;
				}
			})
		},

	},
}
